import { graphql } from "@/gql";

export const createCallbackLeadMutation = graphql(`
  mutation CreateCallbackLead($input: CreateCallbackLeadInput!) {
    createCallbackLead(input: $input) {
      id
      name
      phone
      email
      status
      source
      snoozed_until
      note
    }
  }
`);

export const logCallbackLeadOutcomeMutation = graphql(`
  mutation LogCallbackLeadOutcome(
    $id: ID!
    $input: LogCallbackLeadOutcomeInput!
  ) {
    logCallbackLeadOutcome(id: $id, input: $input) {
      id
      status
      outcome
      note
      contact_attempts
      last_contacted_at
      snoozed_until
    }
  }
`);

export const startCallbackLeadCallMutation = graphql(`
  mutation StartCallbackLeadCall($id: ID!) {
    startCallbackLeadCall(id: $id) {
      id
      status
      phone
      dial_url
      dialled_at
    }
  }
`);

export const dismissCallbackLeadMutation = graphql(`
  mutation DismissCallbackLead($id: ID!) {
    dismissCallbackLead(id: $id) {
      id
      status
      outcome
    }
  }
`);
